import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CommentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"comment"}/>
}
